// The admin's Memory, Feedback and Audit log pages (R10-Q16).
export const mem = {
  // ---- dates and shared words (memory/format.ts, memory/bits.tsx) ----
  todayAt: "today {time}",
  /** "Fri Oct 2": a day built from its parts. */
  dayName: "{weekday} {month} {day}",
  since: "Since {date}",
  until: "Until {date}",
  anyTime: "Any time",
  all: "All",
  company: "Company",
  personal: "Personal",
  aTeam: "A team",
  onePerson: "One person",
  onlyName: "{name} only",
  anAutomation: "An automation",
  showMore: "Show more",
  shownOf: "{shown} of {total} {what}",
  openDetails: "{what}, open details",
  facts: "facts",
  lessons: "lessons",
  items: "items",
  ratings: "ratings",
  archive: "Archive",
  pinned: "Pinned",
  statusLabel: "Status:",
  personLabel: "Person:",
  everyone: "Everyone",

  // ---- the memory page's words (memory/logic.ts) ----
  weightTitle: "Weight: {w}",
  weightRetired: "retired",
  weightWeak: "weak · one more 👎 retires it",
  weightFading: "fading",
  weightNew: "new",
  weightSteady: "steady",
  weightStrong: "strong",
  notUsedYet: "not used yet",
  applied_one: "applied once",
  applied_other: "applied {n} times",
  fromOwnersDown: "from {name}'s 👎",
  fromDownWithNote: "from a 👎 with a note",
  toldBy: "told by {name} in chat",
  toldInChat: "told in a chat",
  agreedByTeam: "agreed by 2 {team} members",
  agreedBy2: "agreed by 2 members",
  fromUpVotes: "from 👍 votes",
  addedByAdmin: "added by an admin",
  fromSource: "from {source}",
  meterLabel: "{used} of {limit} tokens",
  confHigh: "High",
  confMedium: "Medium",
  confLow: "Low",
  fairlySure: "fairly sure",
  fairlyUnsure: "fairly unsure",
  unsure: "unsure",
  srcChat: "Said in a chat",
  srcChannel: "Heard in a channel",
  srcEmail: "Said in an email",
  srcTool: "Checked in a tool",
  srcAdmin: "Added or edited by an admin",
  srcSeed: "Set up with the workspace",
  srcImport: "Imported from the old Vantage",
  usedInAnswers_one: "used in {n} answer",
  usedInAnswers_other: "used in {n} answers",
  stCurrent: "Current",
  stScheduled: "Scheduled",
  stExpired: "Expired",
  stReplaced: "Replaced",
  stArchived: "Archived",
  wCurrent: "current",
  wScheduled: "scheduled",
  wExpired: "expired",
  wReplaced: "replaced",
  wArchived: "archived",

  // ---- Memory page and tabs ----
  memory: "Memory",
  memorySub:
    "Admins only. Company facts inform everyone's answers; team facts stay inside their team.",
  tabFacts: "Facts",
  tabLessons: "Lessons",
  tabBriefing: "Briefing",
  tabReview: "Review",
  waitingForYou: "{n} waiting for you",

  // ---- Add a fact ----
  add: "Add",
  aFact: "a fact",
  addFact: "Add a fact",
  savedForTeam: "Saved for {team}.",
  theTeam: "the team",
  savedForCompany: "Saved for the company.",
  couldntSaveFact: "Couldn't save the fact.",
  statement: "Statement",
  phStatement: "Staging deploys happen on Thursdays",
  about: "About",
  topic: "Topic",
  phTopic: "deploy day",
  belongsTo: "Belongs to",
  companyEveryone: "Company (everyone)",
  validUntil: "Valid until",
  pinnedHelpNew: "Always in the briefing, even when it's full.",
  replaceHelp:
    "The same About and Topic as a current fact replaces it; the old one stays in its history. Anything else is a new fact.",
  saveFact: "Save the fact",

  // ---- Facts ----
  startsOn: "starts {date}",
  expiredOn: "expired {date}",
  dueToday: "today",
  dueTomorrow: "tomorrow",
  daysLeft_one: "{n} day left",
  daysLeft_other: "{n} days left",
  untilDate: "until {date}",
  aliasNoEnd: "alias · no end date",
  noEndDateLower: "no end date",
  pinnedAlways: "Pinned: always in the briefing",
  recentlyExpired: "Recently expired, kept as history",
  nothingExpired: "Nothing has expired yet.",
  showAllExpired: "Show all {n} expired facts",
  searchMemoryPh: "Search memory…",
  searchMemory: "Search memory",
  theFacts: "the facts",
  nothingMatches: "Nothing matches",
  noFactsYet: "No facts here yet",
  searchHelp: "Search looks at statements, names and meaning, in English and Vietnamese.",
  factsEmptyHelp: "Vantage remembers what people say in chats and listening channels.",
  best50: "The 50 best matches",
  nMatches: "{n} matches",
  forQuery: "for “{q}”",

  // ---- the fact's panel ----
  verCurrent: "Current · since {date} · {source}",
  verScheduled: "Scheduled · from {date} · {source}",
  later: "later",
  sinceDate: "since {date}",
  savedNewVersion: "Saved as a new version. The old one stays in its history.",
  couldntSave: "Couldn't save.",
  pinnedToast: "Pinned: it always stays in the briefing.",
  unpinned: "Unpinned.",
  factDetails: "Fact details",
  fact: "Fact",
  thisFact: "this fact",
  removeEndDate: "Remove the end date",
  noEndDate: "No end date",
  pinnedHelp: "Pinned facts always stay in the briefing, even when it's full.",
  whereFrom: "Where it came from",
  source: "Source",
  how: "How",
  confidence: "Confidence",
  usedInLabel: "Used in",
  answers_one: "{n} answer",
  answers_other: "{n} answers",
  noAnswersYet: "No answers yet",
  status: "Status",
  statusSince: "{status} · since {date}",
  historyOfTopic: "History of this topic",
  onlyReplaced:
    "Only “{about} · {topic}” gets replaced. Other facts about {about} are never touched.",
  archiveFactQ: "Archive this fact?",
  archiveFactBody: "Vantage stops using “{statement}”. It stays in the topic's history.",
  archivedFact: "Archived. Vantage no longer uses it.",

  // ---- Lessons ----
  makeItTeams: "Make it {team}'s",
  makeItCompanys: "Make it the company's",
  nowCompanyLesson: "It's the company's lesson now.",
  nowTeamLesson: "It's {team}'s lesson now.",
  lessonSaved: "Lesson saved.",
  lessonText: "Lesson text",
  keepDoing: "keep doing",
  archivedLesson: "Archived. Vantage stops applying it.",
  restored: "Restored.",
  restore: "Restore",
  automations: "Automations",
  retired: "Retired",
  searchLessonsPh: "Search lessons…",
  searchLessons: "Search lessons",
  lessonsNote:
    "Lessons are how we work: habits and formats Vantage learned from 👍 and 👎. Facts are what's true. A person's own lesson beats the team's for them. Later 👍 strengthen a lesson; repeated 👎 weaken it until it retires.",
  theLessons: "the lessons",
  noLessonsYet: "No lessons here yet",
  lessonsEmptyHelp:
    "A 👎 with a note teaches the person who gave it at once; two teammates agreeing make it the team's.",

  // ---- Briefing ----
  holdsInMind: "What Vantage holds in mind",
  holdsInMindIn: "What Vantage holds in mind in {place}",
  loadedEveryTurn:
    "Loaded at the start of every turn, before any search. Rebuilt whenever memory changes.",
  viewingAs: "Viewing as:",
  teamsChannel: "A team's channel",
  teamMember: "{team} member",
  personsOwnChat: "A person's own chat",
  theBriefing: "the briefing",
  size: "Size",
  briefingSize: "Briefing size",
  nSections: "{n} sections",
  everythingFits: "everything fits",
  leftOut_one: "{n} fact left out to fit ({ids}); Vantage still finds them by search",
  leftOut_other: "{n} facts left out to fit ({ids}); Vantage still finds them by search",
  showBySection: "Show by section",
  showPlain: "Show as plain text",
  nothingHereYet: "Nothing here yet",
  briefingFoot:
    "Only what this audience may read appears here: another team's facts never do. To change what Vantage knows, edit the facts; this view follows.",

  // ---- Review ----
  aLesson: "A lesson",
  foundWhen: "found {when}",
  wouldReplace: "Would replace: “{current}”",
  dismissed: "Dismissed.",
  saved: "Saved.",
  reviewNote: "Vantage wasn't sure where these belong, so it's asking instead of guessing.",
  theReviewQueue: "the review queue",
  nothingToReview: "Nothing to review",
  reviewEmptyHelp: "When Vantage isn't sure where something belongs, it waits here for you.",

  // ---- the date range (feedback/DateRange.tsx) ----
  today: "Today",
  last7: "Last 7 days",
  last30: "Last 30 days",
  datesFor: "Dates: {label}",
  dates: "Dates",
  from: "From",
  to: "To",

  // ---- Feedback ----
  feedback: "Feedback",
  feedbackSub: "Admins only. Who rated what stays private to the giver and admins.",
  good: "Good",
  needsWork: "Needs work",
  flagged: "Flagged",
  reasonLabel: "Reason:",
  any: "Any",
  teamLabel: "Team:",
  ratingsCount_one: "{n} rating",
  ratingsCount_other: "{n} ratings",
  newestFirst: "newest first",
  theFeedback: "the feedback",
  noRatingsMatch: "No ratings match these filters.",
  newestCap: "These are the newest {n}: pick dates to see older ones.",
  flagsFoot:
    "Flags only mark feedback: whoever builds Vantage turns them into tests and fixes, with the names and details rewritten. Nothing here changes Vantage by itself.",
  flagTestChip: "Test wanted",
  flagTestRemove: "Remove the test-wanted flag",
  flagTestAdd: "Flag: test wanted",
  flagBugChip: "Bug",
  flagBugRemove: "Remove the bug flag",
  flagBugAdd: "Flag: bug",
  them: "them",
  justName: "Just {name}",
  lessonForAlone: "A lesson for {name} alone.",
  lessonForNow: "A lesson for {where} now.",
  couldntMakeLesson: "Couldn't make the lesson.",
  makeLesson: "Make a lesson",
  makeLessonFor: "Make a lesson for",
  theLesson: "The lesson",
  phLesson: "When listing tickets, include the owner",
  lessonRule: "One short rule: no names, tickets, clients or numbers.",
  makeTheLesson: "Make the lesson",
  couldntSaveFlag: "Couldn't save the flag.",
  someone: "someone",
  goodAnswer: "Good answer",
  noNote: "No note",
  noText: "(no text)",
  openTrace: "Open trace",

  // ---- the scorecard (feedback/logic.ts, Scorecard.tsx) ----
  ofN: "of {n}",
  laneFast: "Fast",
  laneDeep: "Deep",
  laneAutomation: "Automation",
  upRate: "👍 rate",
  ofRated: "{up} of {rated} rated",
  slowAnswers: "slow answers (> 10 s)",
  aOfB: "{a} of {b}",
  costPerAnswer: "cost per answer",
  noAnswersYetLower: "no answers yet",
  ofAnswersRated: "of answers rated",
  personsLesson: "{name}'s lesson",
  teamsLesson: "{team}'s lesson",
  theTeamCap: "The team",
  companyLesson: "Company lesson",
  automationsLesson: "Automation's lesson",
  lessonRetired: "Lesson retired",
  stateLesson: "{state} lesson",
  voteOnly: "Vote only",
  raisedWeight: "raised the weight of the lessons this answer used",
  slowNotCounted: "a slow answer doesn't count against the lessons it used",
  loweredWeight: "lowered the weight of the lessons this answer used",
  noLesson: "No lesson",
  noteNoRule: "the note didn't make a general rule (it may correct a fact, or still be checked)",
  aChannel: "a channel",
  dm: "DM",
  chatWithVantage: "Chat with Vantage",
  inbox: "Inbox",
  upRateByTeam: "👍 rate by team",
  noRatingsYet: "No ratings yet.",
  upRateByLane: "👍 rate by lane",
  topDownReasons: "Top 👎 reasons",
  noDownInDates: "No 👎 in these dates.",
  downsInAll: "{n} 👎 in all. One 👎 can carry several reasons.",
  scorecard: "Scorecard",
  followsDates: "follows the dates above",
  last7Unless: "the last 7 days unless you pick dates",
  theScorecard: "the scorecard",

  // ---- the Audit log (audit/logic.ts, AuditPage.tsx) ----
  allTools: "All tools",
  plRedmineUpdate: "Updated {n} tickets in Redmine",
  plRedmineCreate: "Created {n} tickets in Redmine",
  plRedmineNote: "Added notes to {n} tickets in Redmine",
  plRedmineDelete: "Deleted {n} tickets in Redmine",
  plGithubComment: "Commented on {n} items in GitHub",
  plGithubCreate: "Opened {n} issues in GitHub",
  plGithubUpdate: "Updated {n} issues in GitHub",
  plOutlineUpdate: "Updated {n} docs in Outline",
  plOutlineDelete: "Deleted {n} docs from Outline",
  plOutlineArchive: "Archived {n} docs in Outline",
  moreChanges: "{n} more changes",
  anUndo: "An undo",
  undone: "Undone",
  undoneBy: "Undone by {name}",
  undoAvailable: "Undo available",
  changedSince: "Changed since: can't undo",
  undoExpired: "Undo expired",
  noUndo: "No undo",
  undoOfEarlier: "An undo of an earlier change",
  partlyUndoneChanged: "Partly undone: changed since",
  partlyUndone: "Partly undone",
  undoWindowEnded: "Undo window ended {when}",
  availableUntil: "Available until {when}",
  viaWeb: "web",
  viaEmail: "email",
  viaAutomation: "automation",
  viaAdmin: "admin screens",
  viaUndo: "undo",
  viaSystem: "Vantage, by itself",
  nobody: "nobody",
  nothing: "nothing",
  anAdminScreen: "an admin screen",
  anAutomationLower: "an automation",
  noConversation: "no conversation",
  aConversation: "a conversation",
  inChannel: "in #{name}",
  aDm: "a DM",
  theInbox: "the Inbox",
  chatWithVantageLower: "chat with Vantage",
  undidN: "Undid {n}.",
  undoneDot: "Undone.",
  undidChanges: "Undid {n} changes.",
  undoAll: "Undo all",
  undoAllQ: "Undo all {n} changes?",
  undoAllBody: "Each of the {n} changes is put back as it was, where it still can be.",
  undoAllN: "Undo all {n}",
  nChanges: "{n} changes",
  changeDetails: "Change details",
  change: "Change",
  whatHappened: "What happened",
  askedBy: "Asked by",
  openMessage: "Open message",
  when: "When",
  via: "Via",
  removed: "{value} (removed)",
  openIn: "Open in {tool}",
  undoThisOne: "Undo this one",
  nameOrAdminCanUndo: "{name} or an admin can undo",
  anAdminCanUndo: "An admin can undo",
  auditLog: "Audit log",
  auditSub:
    "Admins only. Everything Vantage changed, who asked for it, and whether it can be undone.",
  tool: "Tool",
  theAuditLog: "the audit log",
  nothingHere: "Nothing here",
  noChangesMatch: "No changes match these filters.",
  loadOlder: "Load older",
  newestFirstCap: "Newest first",
  thatsEverything: "that's everything",
};
